import { useGetMatchInfo } from "@/api/services/main/match";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { MatchForm } from "@/features/match/components/MatchForm";
import { convertMatchRes } from "@/features/match/utils/convertMatch";

export const MatchEditPage = () => {
  const { data, isLoading } = useGetMatchInfo();

  if (isLoading) return <LoadingPage />;

  return <MatchForm defaultValues={convertMatchRes(data?.data)} />;
};
